import local from './local';
import development from './development';
import test from './test';
import preproduction from './preproduction';
import production from './production';

const envs = {
  localhost: local,
  'dev.': development,
  'test.': test,
  'pre.': preproduction,
};

// eslint-disable-next-line no-undef
const { host } = window.location;
let environment = production;

Object.keys(envs).forEach((item) => {
  if (host.match(item)) {
    environment = envs[item];
  }
});

const env = environment;
export default env;



/** WEBPACK FOOTER **
 ** ./src/environments/index.js
 **/